// color: full HEX, opacity: 0-1
const alphaColor = (color: string, opacity = 1) => {
  const hexOpacity = opacity ? Math.trunc(Math.min(opacity, 1) * 255).toString(16) : '00'
  return `${color}${hexOpacity.length > 1 ? hexOpacity : `0${hexOpacity}`}`
}

export const helpersColor = {
  alphaColor,
}
